import WebhookApi from 'api/webhooks';
import Preloader from 'vcomponents/utilities/Preloader.vue';
import { v4 as uuidv4 } from 'uuid';

export default {
    props: {
        logs: {
            type: Array,
            required: true,
            default: [],
        },
        hookType: {
            type: String,
            required: true,
            default: 'http',
        },
        id: {
            type: Number,
            required: false,
        },
    },
    components: {
        Preloader,
    },
    data() {
        return {
            form: {
                endpoint: '',
                type: this.hookType,
                is_enabled: false,
                object_in_payload: false,
                json_content_type: false,
                sign_key: uuidv4(),
                configuration: [],
            },
            errors: {},
            loading: false,
            rules: {
                endpoint: [
                    {
                        required: true,
                        type: 'url',
                        message: this.$l10n.__('Veuillez renseigner un endpoint valide.'),
                    },
                ],
            },
        };
    },
    created() {
        this.configurizeLogs();

        if (!_.isNil(this.id)) {
            this.getWebhookConfig();
        }
    },
    methods: {
        handleSwitch(event, row) {
            const configIndex = this.form.configuration.findIndex((config) => config.id === row.id);
            Vue.set(this.form.configuration, configIndex, { ...row, is_enabled: event });
        },
        activeEvents(logId) {
            return this.getAllEventsForParentLog(logId).filter((event) => event.is_enabled).length;
        },
        /**
         * Format Configuration with logs
         */
        configurizeLogs() {
            this.form.configuration = this.logs.flatMap((log) => {
                return Object.entries(log.events).map((event) => {
                    const formattedEvent = {
                        label: event[1],
                        id: `${log.id}.${event[0]}`,
                        is_enabled: false,
                    };

                    if (!_.isNil(log.parent)) formattedEvent.parent = log.parent;
                    if (this.hookType === 'slack') formattedEvent.channel = '';
                    return formattedEvent;
                });
            });
        },
        /**
         * Get Table title by log
         */
        getTableTitleByLog(log) {
            const notifs = Object.keys(log.events).length;
            const actives = this.activeEvents(log.id);
            return `${log.description} 
                ${this.$l10n.n__(
                    '(%(notifs)s notifications %(actives)s activée)',
                    '(%(notifs)s notifications %(actives)s activées)',
                    { notifs: notifs, actives: actives },
                    { notifs: notifs, actives: actives },
                )}`;
        },
        /**
         * Get Webhook config on already created hook
         */
        getWebhookConfig() {
            this.loading = true;
            WebhookApi.getWebhook(this.id).then((response) => {
                this.form = {
                    ...this.form,
                    ...response.data,
                    configuration: [...this.form.configuration],
                };
                response.data.configuration.forEach((event) => {
                    const eventIndex = this.form.configuration.findIndex(
                        (formEvent) => formEvent.id === event.id,
                    );
                    this.form.configuration[eventIndex] = {
                        ...this.form.configuration[eventIndex],
                        ...event,
                    };
                });
                this.loading = false;
            });
        },

        /**
         * Get FormConfig by log
         */
        getEventsConfigByLog(logId) {
            return this.form.configuration.filter((config) => config.id.split('.')[0] === logId);
        },

        /**
         * Get All FormConfig for Parent Log
         */
        getAllEventsForParentLog(logId) {
            return this.form.configuration.filter((config) =>
                [config.parent, config.id.split('.')[0], config.id.split('_')[0]].includes(logId),
            );
        },

        /**
         * Get FormConfig by log
         */
        getLogsChildByLog(logId) {
            return this.logs.filter((log) => !_.isNil(log.parent) && log.parent === logId);
        },

        /**
         * Get webhook event name
         */
        getWebhookEventName(id) {
            return id.split('.')[1];
        },

        /**
         * Submit Webhook Form
         */
        submit() {
            this.loading = true;
            const request = this.id
                ? WebhookApi.updateWebhook(this.id, this.form)
                : WebhookApi.createWebhook(this.form);
            request
                .then(() => {
                    this.loading = false;
                    EventBus.emit('webhook:close');
                    EventBus.emit('webhooks:refresh');
                })
                .catch((error) => {
                    this.loading = false;
                    Push.error(
                        error?.response?.data?.error?.message ??
                            this.$l10n.__("Une erreur est survenue lors de l'enregistrement."),
                    );
                    this.errors = error.response.data.error.details;
                });
        },
    },
};
